module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/detail/project-detail-widget-detail/project-detail-widget-detail.component.scss
// module id = ./src/app/projects/detail/project-detail-widget-detail/project-detail-widget-detail.component.scss
// module chunks = main